import { z } from "zod";
export const linkPhoneRequestSchema = z.object({
    phoneNumber: z
        .string()
        .min(10, "Phone number is too short")
        .max(15, "Phone number is too long")
        .regex(/^\+?[1-9]\d{6,14}$/, "Invalid phone number format"),
});
export const verifyOtpRequestSchema = z.object({
    otp: z.string().regex(/^\d{6}$/, "OTP must be 6 digits"),
    phoneNumber: z
        .string()
        .min(10, "Phone number is too short")
        .max(15, "Phone number is too long")
        .regex(/^\+?[1-9]\d{6,14}$/, "Invalid phone number format"),
});
export const unlinkPhoneRequestSchema = z.object({
    phoneNumber: z
        .string()
        .min(10, "Phone number is too short")
        .max(15, "Phone number is too long")
        .regex(/^\+?[1-9]\d{6,14}$/, "Invalid phone number format"),
});
export const whatsappPhoneLinkSchema = z.object({
    phoneNumber: z.string(),
    isVerified: z.boolean(),
    verifiedAt: z.string().optional(),
    createdAt: z.string(),
});
export const whatsappLinkStatusSchema = z.object({
    linked: z.boolean(),
    phones: z.array(whatsappPhoneLinkSchema),
});
export const verifyOtpResponseSchema = z.object({
    verified: z.boolean(),
    message: z.string(),
});
